import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import AddToCartButton from 'Checkout/Cart/AddToCartButton'
import AriaModal from 'react-aria-modal'

class ModalVoltage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showConfirmVoltage: false
    }
  }

  confirmVoltage () {
    this.setState({ showConfirmVoltage: !this.state.showConfirmVoltage })
  }

  getApplicationNode = () => {
    return document.querySelector('#root')
  }

  removeTabIndex () {
    setTimeout(() => {
      const contentModalVoltage = document.querySelector('#modal-voltage')
      contentModalVoltage && contentModalVoltage.removeAttribute('tabindex')
    }, 300)
  }

  render () {
    return (
      <Fragment>
        <Button
          id={'voltagem'}
          text='Adicionar ao Carrinho'
          iconName='icon_cart'
          className='btn-icon btn btn-sm txt-uppercase txt-center btn-featured'
          onClick={() => this.confirmVoltage()}
        />

        {this.state.showConfirmVoltage && <AriaModal
          titleText='Confirme o produto'
          onExit={() => this.confirmVoltage()}
          initialFocus='#modal-voltage'
          getApplicationNode={this.getApplicationNode}
          underlayStyle={{ paddingTop: '100px', zIndex: 9999 }}
          focusDialog
          alert
        >
          <div data-campaign={process.env.REACT_APP_CATALOG_ID}>
            <div
              id='modal-voltage'
              onBlur={this.removeTabIndex}
              tabIndex={0}
              className={`modal-voltage col-12 bg-white py-3 mr-auto ml-auto`}
            >
              <div className='row px-3'>
                <div className='col'>
                  <h1 id='modal-question-voltage' className='h3 txt-font-title'>Tem certeza que deseja o produto com a voltagem escolhida?</h1>
                </div>
              </div>
              <div className='col-12'>
                <div className='row'>
                  <div className='modal-back col-12 col-md-6 txt-right mt-3'>
                    <Button
                      id={'confirmar-voltagem'}
                      name={'confirmar-voltagem'}
                      className='btn btn-sm mx-0'
                      text='Voltar'
                      onClick={() => this.confirmVoltage()}
                    />
                  </div>
                  <div className='modal-back col-12 col-md-6 txt-right mt-3'>
                    <AddToCartButton sku={this.props.sku} vendorId={this.props.vendorId} goToCheckout className='btn-featured' noIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AriaModal> }

      </Fragment>
    )
  }
}
ModalVoltage.propTypes = {
  sku: PropTypes.string,
  vendorId: PropTypes.string
}

export default ModalVoltage



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/ModalVoltage/index.js